export const SET_NEARBY_PROPERTY_WIDGET_LISTING = 'SET_NEARBY_PROPERTY_WIDGET_LISTING';
export const WIDGET_SLIDE_TO = 'WIDGET_SLIDE_TO';
export const FETCHING_WIDGET_DATA = 'FETCHING_WIDGET_DATA';
